// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1VSDn","inputWrap":"Table_inputWrap__7EKFS","col":"Table_col__3dD2e","bmiTooltip":"Table_bmiTooltip__2RQmy"};